import { extensionTitle } from '@confluence/forge-ui/entry-points/extensionTitle.ts';
import { EXTENSION_TYPE } from '@confluence/fabric-extension-lib/entry-points/extensionConstants.ts';

const fireAnalyticsEvent = (createAnalyticsEvent, sourceNode, targetAttributes) => {
	if (!createAnalyticsEvent) {
		return;
	}

	const sourceAttributes = {
		sourceNodeType: sourceNode.type,
	};

	// Source is Connect macro
	if (
		sourceNode.type === 'extension' &&
		sourceNode.attrs?.extensionType === EXTENSION_TYPE.MACRO_CORE
	) {
		Object.assign(sourceAttributes, {
			sourceExtensionType: sourceNode.attrs?.extensionType,
			sourceExtensionKey: sourceNode.attrs?.extensionKey,
			sourceExtensionTitle: sourceNode.attrs?.parameters?.macroMetadata?.title,
			sourceExtensionParameters: sourceNode.attrs?.parameters,
		});
	}

	// Source is a Table
	if (sourceNode.type === 'table') {
		Object.assign(sourceAttributes, {
			sourceExtensionType: 'table',
		});
	}

	// Source is a Chart
	if (
		sourceNode.type === 'extension' &&
		sourceNode.attrs?.extensionType === 'com.atlassian.chart'
	) {
		Object.assign(sourceAttributes, {
			sourceExtensionType: sourceNode.attrs?.extensionType,
			sourceExtensionKey: sourceNode.attrs?.extensionKey,
			sourceExtensionTitle: sourceNode.attrs?.parameters?.extensionTitle,
			sourceExtensionParameters: sourceNode.attrs?.parameters,
		});
	}

	const analyticsData = {
		type: 'sendUIEvent',
		data: {
			action: 'clicked',
			actionSubject: 'button',
			actionSubjectId: 'createReference',
			source: 'editorFloatingToolbar',
			attributes: {
				...sourceAttributes,
				...targetAttributes,
			},
		},
	};
	createAnalyticsEvent(analyticsData).fire();
};

export const fireAnalyticsEventForConnect = (
	createAnalyticsEvent: any,
	sourceNode: any,
	targetMacro: any,
): void => {
	fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
		targetNodeType: 'extension',
		targetExtensionType: EXTENSION_TYPE.MACRO_CORE,
		targetExtensionKey: targetMacro.macroName,
		targetExtensionTitle: targetMacro.title,
		targetMacro,
	});
};

export const fireAnalyticsEventForForge = (
	createAnalyticsEvent: any,
	sourceNode: any,
	targetMacro: any,
): void => {
	fireAnalyticsEvent(createAnalyticsEvent, sourceNode, {
		targetNodeType: 'extension',
		targetExtensionType: 'com.atlassian.ecosystem',
		targetExtensionKey: targetMacro.id.replace('ari:cloud:ecosystem::extension/', ''),
		targetExtensionTitle: extensionTitle(targetMacro),
		targetMacro,
	});
};

export const fireAnalyticsEventForConnectionsButton = (
	createAnalyticsEvent: any,
	node: any,
): void => {
	fireAnalyticsEvent(createAnalyticsEvent, node, {});
};
